<template>
  <AnalyticsUpselling v-if="free" />
  <AnalyticsWrapper v-else />
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import { TrackClickEvents, useTrack } from '@/composables/useTrack';
import { useOrganizationStore } from '@/store/useOrganizationStore';

import AnalyticsWrapper from './AnalyticsWrapper.vue';
import AnalyticsUpselling from './AnalyticsUpselling.vue';

const { free } = storeToRefs(useOrganizationStore());
const { trackClick } = useTrack();

onMounted(() => trackClick(TrackClickEvents.VIEWER_ANALYTICSTAB));
</script>
